import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { WhyPrice } from './components/WhyPrice';
import { Problem } from './components/Problem';
import { Agitator } from './components/Agitator';
import { Revelation } from './components/Revelation';
import { Plan48 } from './components/Plan48';
import { Curriculum } from './components/Curriculum';
import { WhatYouGet } from './components/WhatYouGet';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen font-sans bg-white text-body selection:bg-primary/30 selection:text-primary" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <WhyPrice data-id="element-4" />
      <Problem data-id="element-5" />
      <Agitator data-id="element-6" />
      <Revelation data-id="element-7" />
      <Plan48 data-id="element-8" />
      <Curriculum data-id="element-9" />
      <WhatYouGet data-id="element-10" />
      <ValueStack data-id="element-11" />
      <Guarantee data-id="element-12" />
      <Pricing data-id="element-13" />
      <FAQ data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
      <RecentPurchaseToast data-id="element-17" />
    </div>;
}